import {
  Text,
  VStack,
  FormControl,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import {
  setAdditionalBrokerNote,
  useLegacyAutoFormLocked,
} from 'reducers/legacyAutoFormReducer';

const AdditionalNotesSection = () => {
  const dispatch = useAppDispatch();
  const isLocked = useLegacyAutoFormLocked();

  const additionalBrokerNote = useAppSelector(
    (state) => state.legacyAutoForm.data.additional_info.additional_broker_note,
  );

  const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(setAdditionalBrokerNote(event.target.value));
  };

  return (
    <Card mb="20px" id="sectionAdditionalNotes">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Additional Broker Note
      </Text>

      <VStack spacing={4} align="stretch">
        <FormControl>
          <FormLabel ml="0">Notes</FormLabel>
          <Textarea
            value={additionalBrokerNote}
            onChange={handleNoteChange}
            placeholder="Enter any additional notes..."
            rows={4}
            isDisabled={isLocked}
          />
        </FormControl>
      </VStack>
    </Card>
  );
};

export default AdditionalNotesSection;
